
import logo from "../../../../public/projects/Lodha/images/logo/logo.png";
import divino from "../../../../public/projects/Lodha/images/projects/divino.webp"
import giardino from "../../../../public/projects/Lodha/images/projects/giardino.jpg"

// Lodha Divino
import overviewImage_lodha_divino from "../../../../public/projects/Lodha/images/divino/Overview/1.webp";
import bannerDesktopImage_lodha_divino from "../../../../public/projects/Lodha/images/divino/Banner/1.webp";
import bannerMobileImage_lodha_divino from "../../../../public/projects/Lodha/images/divino/Banner/2.webp";
import siteVisitBannerImage_lodha_divino from "../../../../public/projects/Lodha/images/divino/SiteVisitBanner/1.webp";
import Location_lodha_divino from "../../../../public/projects/Lodha/images/divino/Location/L1.webp";
import Hightlights_lodha_divino from "../../../../public/projects/Lodha/images/divino/Highlights/1.webp";
import floorplan1_lodha_divino from "../../../../public/projects/Lodha/images/divino/floorplan/1.webp";
import floorplan2_lodha_divino from "../../../../public/projects/Lodha/images/divino/floorplan/2.webp";
import floorplan3_lodha_divino from "../../../../public/projects/Lodha/images/divino/floorplan/3.webp";
import floorplan4_lodha_divino from "../../../../public/projects/Lodha/images/divino/floorplan/4.webp";
import locationicon_lodha_divino from "../../../../public/projects/Lodha/images/divino/Overview/l.png";
import calicon_lodha_divino from "../../../../public/projects/Lodha/images/divino/Overview/c.png";
import newlaunchicon_lodha_divino from "../../../../public/projects/Lodha/images/divino/Overview/n.png";
import gallery1_lodha_divino from "../../../../public/projects/Lodha/images/divino/Gallery/1.webp";
import gallery2_lodha_divino from "../../../../public/projects/Lodha/images/divino/Gallery/2.webp";
import gallery3_lodha_divino from "../../../../public/projects/Lodha/images/divino/Gallery/3.webp";
import gallery4_lodha_divino from "../../../../public/projects/Lodha/images/divino/Gallery/4.webp";
import gallery5_lodha_divino from "../../../../public/projects/Lodha/images/divino/Gallery/5.webp";

// Lodha Giardino 
import overviewImage_giardino from "../../../../public/projects/Lodha/images/giadino/Overview/1.webp";
import bannerDesktopImage_giardino from "../../../../public/projects/Lodha/images/giadino/Banner/1.webp";
import bannerMobileImage_giardino from "../../../../public/projects/Lodha/images/giadino/Banner/2.webp";
import siteVisitBannerImage_giardino from "../../../../public/projects/Lodha/images/giadino/SiteVisitBanner/1.webp";
import Location_giardino from "../../../../public/projects/Lodha/images/giadino/Location/L1.webp";
import Hightlights_giardino from "../../../../public/projects/Lodha/images/giadino/Highlights/1.webp";
import floorplan1_giardino from "../../../../public/projects/Lodha/images/giadino/floorplan/1.webp";
import floorplan2_giardino from "../../../../public/projects/Lodha/images/giadino/floorplan/2.webp";
import floorplan3_giardino from "../../../../public/projects/Lodha/images/giadino/floorplan/3.webp";
import locationicon_giardino from "../../../../public/projects/Lodha/images/giadino/Overview/l.png";
import calicon_giardino from "../../../../public/projects/Lodha/images/giadino/Overview/c.png";
import newlaunchicon_giardino from "../../../../public/projects/Lodha/images/giadino/Overview/n.png";
import gallery1_giardino from "../../../../public/projects/Lodha/images/giadino/Gallery/1.webp";
import gallery2_giardino from "../../../../public/projects/Lodha/images/giadino/Gallery/2.webp";
import gallery3_giardino from "../../../../public/projects/Lodha/images/giadino/Gallery/3.webp";
import gallery4_giardino from "../../../../public/projects/Lodha/images/giadino/Gallery/4.webp";
import gallery5_giardino from "../../../../public/projects/Lodha/images/giadino/Gallery/5.webp";

// hosaroad
import overviewImagehosaroad from "../../../../public/projects/Lodha/images/hosaroad/overview/1.webp";
import bannerDesktopImagehosaroad from "../../../../public/projects/Lodha/images/hosaroad/banner/1.webp";
import bannerMobileImagehosaroad from "../../../../public/projects/Lodha/images/hosaroad/banner/2.webp";
import Locationhosaroad from "../../../../public/projects/Lodha/images/hosaroad/location/1.webp";
import Hightlightshosaroad from "../../../../public/projects/Lodha/images/hosaroad/highlights/1.webp";
import floorplan1hosaroad from "../../../../public/projects/Lodha/images/hosaroad/floorplan/1.webp";
import floorplan2hosaroad from "../../../../public/projects/Lodha/images/hosaroad/floorplan/2.webp";
import floorplan3hosaroad from "../../../../public/projects/Lodha/images/hosaroad/floorplan/3.webp";
import floorplan4hosaroad from "../../../../public/projects/Lodha/images/hosaroad/floorplan/4.webp";
import floorplan5hosaroad from "../../../../public/projects/Lodha/images/hosaroad/floorplan/5.webp";
import locationiconhosaroad from "../../../../public/projects/Lodha/images/hosaroad/overview/l.png";
import caliconhosaroad from "../../../../public/projects/Lodha/images/hosaroad/overview/c.png";
import newlaunchiconhosaroad from "../../../../public/projects/Lodha/images/hosaroad/overview/n.png";
import gallery1hosaroad from "../../../../public/projects/Lodha/images/hosaroad/gallery/1.webp";
import gallery2hosaroad from "../../../../public/projects/Lodha/images/hosaroad/gallery/2.webp";
import gallery3hosaroad from "../../../../public/projects/Lodha/images/hosaroad/gallery/3.webp";
import gallery4hosaroad from "../../../../public/projects/Lodha/images/hosaroad/gallery/4.webp";
import gallery5hosaroad from "../../../../public/projects/Lodha/images/hosaroad/gallery/5.webp";

// panache
import overviewImagepanache from "../../../../public/projects/Lodha/images/panache/overview/1.webp";
import bannerDesktopImagepanache from "../../../../public/projects/Lodha/images/panache/banner/1.webp";
import bannerMobileImagepanache from "../../../../public/projects/Lodha/images/panache/banner/2.webp";
import Locationpanache from "../../../../public/projects/Lodha/images/panache/location/1.webp";
import Hightlightspanache from "../../../../public/projects/Lodha/images/panache/highlights/1.webp";
import floorplan1panache from "../../../../public/projects/Lodha/images/panache/floorplan/1.webp";
import floorplan2panache from "../../../../public/projects/Lodha/images/panache/floorplan/2.webp";
import floorplan3panache from "../../../../public/projects/Lodha/images/panache/floorplan/3.webp";
import floorplan4panache from "../../../../public/projects/Lodha/images/panache/floorplan/4.webp";
import floorplan5panache from "../../../../public/projects/Lodha/images/panache/floorplan/5.webp";
import locationiconpanache from "../../../../public/projects/Lodha/images/panache/overview/l.png";
import caliconpanache from "../../../../public/projects/Lodha/images/panache/overview/c.png";
import newlaunchiconpanache from "../../../../public/projects/Lodha/images/panache/overview/n.png";
import gallery1panache from "../../../../public/projects/Lodha/images/panache/gallery/1.webp";
import gallery2panache from "../../../../public/projects/Lodha/images/panache/gallery/2.webp";
import gallery3panache from "../../../../public/projects/Lodha/images/panache/gallery/3.webp";
import gallery4panache from "../../../../public/projects/Lodha/images/panache/gallery/4.webp";
import gallery5panache from "../../../../public/projects/Lodha/images/panache/gallery/5.webp";

// magnus
import overviewImagemagnus from "../../../../public/projects/Lodha/images/magnus/overview/1.webp";
import bannerDesktopImagemagnus from "../../../../public/projects/Lodha/images/magnus/banner/1.webp";
import bannerMobileImagemagnus from "../../../../public/projects/Lodha/images/magnus/banner/2.webp";
import Locationmagnus from "../../../../public/projects/Lodha/images/magnus/location/1.webp";
import Hightlightsmagnus from "../../../../public/projects/Lodha/images/magnus/highlights/1.webp";
import floorplan1magnus from "../../../../public/projects/Lodha/images/magnus/floorplan/1.webp";
import floorplan2magnus from "../../../../public/projects/Lodha/images/magnus/floorplan/2.webp";
import floorplan3magnus from "../../../../public/projects/Lodha/images/magnus/floorplan/3.webp";
import floorplan4magnus from "../../../../public/projects/Lodha/images/magnus/floorplan/4.webp";
import floorplan5magnus from "../../../../public/projects/Lodha/images/magnus/floorplan/5.webp";
import locationiconmagnus from "../../../../public/projects/Lodha/images/magnus/overview/l.png";
import caliconmagnus from "../../../../public/projects/Lodha/images/magnus/overview/c.png";
import newlaunchiconmagnus from "../../../../public/projects/Lodha/images/magnus/overview/n.png";
import gallery1magnus from "../../../../public/projects/Lodha/images/magnus/gallery/1.webp";
import gallery2magnus from "../../../../public/projects/Lodha/images/magnus/gallery/2.webp";
import gallery3magnus from "../../../../public/projects/Lodha/images/magnus/gallery/3.webp";
import gallery4magnus from "../../../../public/projects/Lodha/images/magnus/gallery/4.webp";
import gallery5magnus from "../../../../public/projects/Lodha/images/magnus/gallery/5.webp";

// projectthree
import overviewImageprojectthree from "../../../../public/projects/Lodha/images/projectthree/overview/1.webp";
import bannerDesktopImageprojectthree from "../../../../public/projects/Lodha/images/projectthree/banner/1.webp";
import bannerMobileImageprojectthree from "../../../../public/projects/Lodha/images/projectthree/banner/2.webp";
import Locationprojectthree from "../../../../public/projects/Lodha/images/projectthree/location/1.webp";
import Hightlightsprojectthree from "../../../../public/projects/Lodha/images/projectthree/highlights/1.webp";
import floorplan1projectthree from "../../../../public/projects/Lodha/images/projectthree/floorplan/1.webp";
import floorplan2projectthree from "../../../../public/projects/Lodha/images/projectthree/floorplan/2.webp";
import floorplan3projectthree from "../../../../public/projects/Lodha/images/projectthree/floorplan/3.webp";
import floorplan4projectthree from "../../../../public/projects/Lodha/images/projectthree/floorplan/4.webp";
import floorplan5projectthree from "../../../../public/projects/Lodha/images/projectthree/floorplan/5.webp";
import locationiconprojectthree from "../../../../public/projects/Lodha/images/projectthree/overview/l.png";
import caliconprojectthree from "../../../../public/projects/Lodha/images/projectthree/overview/c.png";
import newlaunchiconprojectthree from "../../../../public/projects/Lodha/images/projectthree/overview/n.png";
import gallery1projectthree from "../../../../public/projects/Lodha/images/projectthree/gallery/1.webp";
import gallery2projectthree from "../../../../public/projects/Lodha/images/projectthree/gallery/2.webp";
import gallery3projectthree from "../../../../public/projects/Lodha/images/projectthree/gallery/3.webp";
import gallery4projectthree from "../../../../public/projects/Lodha/images/projectthree/gallery/4.webp";
import gallery5projectthree from "../../../../public/projects/Lodha/images/projectthree/gallery/5.webp";

// projectfour
import overviewImageprojectfour from "../../../../public/projects/Lodha/images/projectfour/overview/1.webp";
import bannerDesktopImageprojectfour from "../../../../public/projects/Lodha/images/projectfour/banner/1.webp";
import bannerMobileImageprojectfour from "../../../../public/projects/Lodha/images/projectfour/banner/2.webp";
import Locationprojectfour from "../../../../public/projects/Lodha/images/projectfour/location/1.webp";
import Hightlightsprojectfour from "../../../../public/projects/Lodha/images/projectfour/highlights/1.webp";
import floorplan1projectfour from "../../../../public/projects/Lodha/images/projectfour/floorplan/1.webp";
import floorplan2projectfour from "../../../../public/projects/Lodha/images/projectfour/floorplan/2.webp";
import floorplan3projectfour from "../../../../public/projects/Lodha/images/projectfour/floorplan/3.webp";
import floorplan4projectfour from "../../../../public/projects/Lodha/images/projectfour/floorplan/4.webp";
import floorplan5projectfour from "../../../../public/projects/Lodha/images/projectfour/floorplan/5.webp";
import locationiconprojectfour from "../../../../public/projects/Lodha/images/projectfour/overview/l.png";
import caliconprojectfour from "../../../../public/projects/Lodha/images/projectfour/overview/c.png";
import newlaunchiconprojectfour from "../../../../public/projects/Lodha/images/projectfour/overview/n.png";
import gallery1projectfour from "../../../../public/projects/Lodha/images/projectfour/gallery/1.webp";
import gallery2projectfour from "../../../../public/projects/Lodha/images/projectfour/gallery/2.webp";
import gallery3projectfour from "../../../../public/projects/Lodha/images/projectfour/gallery/3.webp";
import gallery4projectfour from "../../../../public/projects/Lodha/images/projectfour/gallery/4.webp";
import gallery5projectfour from "../../../../public/projects/Lodha/images/projectfour/gallery/5.webp";

// projectfive
import overviewImageprojectfive from "../../../../public/projects/Lodha/images/projectfive/overview/1.webp";
import bannerDesktopImageprojectfive from "../../../../public/projects/Lodha/images/projectfive/banner/1.webp";
import bannerMobileImageprojectfive from "../../../../public/projects/Lodha/images/projectfive/banner/2.webp";
import Locationprojectfive from "../../../../public/projects/Lodha/images/projectfive/location/1.webp";
import Hightlightsprojectfive from "../../../../public/projects/Lodha/images/projectfive/highlights/1.webp";
import floorplan1projectfive from "../../../../public/projects/Lodha/images/projectfive/floorplan/1.webp";
import floorplan2projectfive from "../../../../public/projects/Lodha/images/projectfive/floorplan/2.webp";
import floorplan3projectfive from "../../../../public/projects/Lodha/images/projectfive/floorplan/3.webp";
import floorplan4projectfive from "../../../../public/projects/Lodha/images/projectfive/floorplan/4.webp";
import floorplan5projectfive from "../../../../public/projects/Lodha/images/projectfive/floorplan/5.webp";
import locationiconprojectfive from "../../../../public/projects/Lodha/images/projectfive/overview/l.png";
import caliconprojectfive from "../../../../public/projects/Lodha/images/projectfive/overview/c.png";
import newlaunchiconprojectfive from "../../../../public/projects/Lodha/images/projectfive/overview/n.png";
import gallery1projectfive from "../../../../public/projects/Lodha/images/projectfive/gallery/1.webp";
import gallery2projectfive from "../../../../public/projects/Lodha/images/projectfive/gallery/2.webp";
import gallery3projectfive from "../../../../public/projects/Lodha/images/projectfive/gallery/3.webp";
import gallery4projectfive from "../../../../public/projects/Lodha/images/projectfive/gallery/4.webp";
import gallery5projectfive from "../../../../public/projects/Lodha/images/projectfive/gallery/5.webp";

// projectsix
import overviewImageprojectsix from "../../../../public/projects/Lodha/images/projectsix/overview/1.webp";
import bannerDesktopImageprojectsix from "../../../../public/projects/Lodha/images/projectsix/banner/1.webp";
import bannerMobileImageprojectsix from "../../../../public/projects/Lodha/images/projectsix/banner/2.webp";
import Locationprojectsix from "../../../../public/projects/Lodha/images/projectsix/location/1.webp";
import Hightlightsprojectsix from "../../../../public/projects/Lodha/images/projectsix/highlights/1.webp";
import floorplan1projectsix from "../../../../public/projects/Lodha/images/projectsix/floorplan/1.webp";
import floorplan2projectsix from "../../../../public/projects/Lodha/images/projectsix/floorplan/2.webp";
import floorplan3projectsix from "../../../../public/projects/Lodha/images/projectsix/floorplan/3.webp";
import floorplan4projectsix from "../../../../public/projects/Lodha/images/projectsix/floorplan/4.webp";
import floorplan5projectsix from "../../../../public/projects/Lodha/images/projectsix/floorplan/5.webp";
import locationiconprojectsix from "../../../../public/projects/Lodha/images/projectsix/overview/l.png";
import caliconprojectsix from "../../../../public/projects/Lodha/images/projectsix/overview/c.png";
import newlaunchiconprojectsix from "../../../../public/projects/Lodha/images/projectsix/overview/n.png";
import gallery1projectsix from "../../../../public/projects/Lodha/images/projectsix/gallery/1.webp";
import gallery2projectsix from "../../../../public/projects/Lodha/images/projectsix/gallery/2.webp";
import gallery3projectsix from "../../../../public/projects/Lodha/images/projectsix/gallery/3.webp";
import gallery4projectsix from "../../../../public/projects/Lodha/images/projectsix/gallery/4.webp";
import gallery5projectsix from "../../../../public/projects/Lodha/images/projectsix/gallery/5.webp";

// projectseven
import overviewImageprojectseven from "../../../../public/projects/Lodha/images/projectseven/overview/1.webp";
import bannerDesktopImageprojectseven from "../../../../public/projects/Lodha/images/projectseven/banner/1.webp";
import bannerMobileImageprojectseven from "../../../../public/projects/Lodha/images/projectseven/banner/2.webp";
import Locationprojectseven from "../../../../public/projects/Lodha/images/projectseven/location/1.webp";
import Hightlightsprojectseven from "../../../../public/projects/Lodha/images/projectseven/highlights/1.webp";
import floorplan1projectseven from "../../../../public/projects/Lodha/images/projectseven/floorplan/1.webp";
import floorplan2projectseven from "../../../../public/projects/Lodha/images/projectseven/floorplan/2.webp";
import floorplan3projectseven from "../../../../public/projects/Lodha/images/projectseven/floorplan/3.webp";
import floorplan4projectseven from "../../../../public/projects/Lodha/images/projectseven/floorplan/4.webp";
import floorplan5projectseven from "../../../../public/projects/Lodha/images/projectseven/floorplan/5.webp";
import locationiconprojectseven from "../../../../public/projects/Lodha/images/projectseven/overview/l.png";
import caliconprojectseven from "../../../../public/projects/Lodha/images/projectseven/overview/c.png";
import newlaunchiconprojectseven from "../../../../public/projects/Lodha/images/projectseven/overview/n.png";
import gallery1projectseven from "../../../../public/projects/Lodha/images/projectseven/gallery/1.webp";
import gallery2projectseven from "../../../../public/projects/Lodha/images/projectseven/gallery/2.webp";
import gallery3projectseven from "../../../../public/projects/Lodha/images/projectseven/gallery/3.webp";
import gallery4projectseven from "../../../../public/projects/Lodha/images/projectseven/gallery/4.webp";
import gallery5projectseven from "../../../../public/projects/Lodha/images/projectseven/gallery/5.webp";

// projecteight
import overviewImageprojecteight from "../../../../public/projects/Lodha/images/projecteight/overview/1.webp";
import bannerDesktopImageprojecteight from "../../../../public/projects/Lodha/images/projecteight/banner/1.webp";
import bannerMobileImageprojecteight from "../../../../public/projects/Lodha/images/projecteight/banner/2.webp";
import Locationprojecteight from "../../../../public/projects/Lodha/images/projecteight/location/1.webp";
import Hightlightsprojecteight from "../../../../public/projects/Lodha/images/projecteight/highlights/1.webp";
import floorplan1projecteight from "../../../../public/projects/Lodha/images/projecteight/floorplan/1.webp";
import floorplan2projecteight from "../../../../public/projects/Lodha/images/projecteight/floorplan/2.webp";
import floorplan3projecteight from "../../../../public/projects/Lodha/images/projecteight/floorplan/3.webp";
import floorplan4projecteight from "../../../../public/projects/Lodha/images/projecteight/floorplan/4.webp";
import floorplan5projecteight from "../../../../public/projects/Lodha/images/projecteight/floorplan/5.webp";
import locationiconprojecteight from "../../../../public/projects/Lodha/images/projecteight/overview/l.png";
import caliconprojecteight from "../../../../public/projects/Lodha/images/projecteight/overview/c.png";
import newlaunchiconprojecteight from "../../../../public/projects/Lodha/images/projecteight/overview/n.png";
import gallery1projecteight from "../../../../public/projects/Lodha/images/projecteight/gallery/1.webp";
import gallery2projecteight from "../../../../public/projects/Lodha/images/projecteight/gallery/2.webp";
import gallery3projecteight from "../../../../public/projects/Lodha/images/projecteight/gallery/3.webp";
import gallery4projecteight from "../../../../public/projects/Lodha/images/projecteight/gallery/4.webp";
import gallery5projecteight from "../../../../public/projects/Lodha/images/projecteight/gallery/5.webp";

// projectnine
import overviewImageprojectnine from "../../../../public/projects/Lodha/images/projectnine/overview/1.webp";
import bannerDesktopImageprojectnine from "../../../../public/projects/Lodha/images/projectnine/banner/1.webp";
import bannerMobileImageprojectnine from "../../../../public/projects/Lodha/images/projectnine/banner/2.webp";
import Locationprojectnine from "../../../../public/projects/Lodha/images/projectnine/location/1.webp";
import Hightlightsprojectnine from "../../../../public/projects/Lodha/images/projectnine/highlights/1.webp";
import floorplan1projectnine from "../../../../public/projects/Lodha/images/projectnine/floorplan/1.webp";
import floorplan2projectnine from "../../../../public/projects/Lodha/images/projectnine/floorplan/2.webp";
import floorplan3projectnine from "../../../../public/projects/Lodha/images/projectnine/floorplan/3.webp";
import floorplan4projectnine from "../../../../public/projects/Lodha/images/projectnine/floorplan/4.webp";
import floorplan5projectnine from "../../../../public/projects/Lodha/images/projectnine/floorplan/5.webp";
import locationiconprojectnine from "../../../../public/projects/Lodha/images/projectnine/overview/l.png";
import caliconprojectnine from "../../../../public/projects/Lodha/images/projectnine/overview/c.png";
import newlaunchiconprojectnine from "../../../../public/projects/Lodha/images/projectnine/overview/n.png";
import gallery1projectnine from "../../../../public/projects/Lodha/images/projectnine/gallery/1.webp";
import gallery2projectnine from "../../../../public/projects/Lodha/images/projectnine/gallery/2.webp";
import gallery3projectnine from "../../../../public/projects/Lodha/images/projectnine/gallery/3.webp";
import gallery4projectnine from "../../../../public/projects/Lodha/images/projectnine/gallery/4.webp";
import gallery5projectnine from "../../../../public/projects/Lodha/images/projectnine/gallery/5.webp";

// projectten
import overviewImageprojectten from "../../../../public/projects/Lodha/images/projectten/overview/1.webp";
import bannerDesktopImageprojectten from "../../../../public/projects/Lodha/images/projectten/banner/1.webp";
import bannerMobileImageprojectten from "../../../../public/projects/Lodha/images/projectten/banner/2.webp";
import Locationprojectten from "../../../../public/projects/Lodha/images/projectten/location/1.webp";
import Hightlightsprojectten from "../../../../public/projects/Lodha/images/projectten/highlights/1.webp";
import floorplan1projectten from "../../../../public/projects/Lodha/images/projectten/floorplan/1.webp";
import floorplan2projectten from "../../../../public/projects/Lodha/images/projectten/floorplan/2.webp";
import floorplan3projectten from "../../../../public/projects/Lodha/images/projectten/floorplan/3.webp";
import floorplan4projectten from "../../../../public/projects/Lodha/images/projectten/floorplan/4.webp";
import floorplan5projectten from "../../../../public/projects/Lodha/images/projectten/floorplan/5.webp";
import locationiconprojectten from "../../../../public/projects/Lodha/images/projectten/overview/l.png";
import caliconprojectten from "../../../../public/projects/Lodha/images/projectten/overview/c.png";
import newlaunchiconprojectten from "../../../../public/projects/Lodha/images/projectten/overview/n.png";
import gallery1projectten from "../../../../public/projects/Lodha/images/projectten/gallery/1.webp";
import gallery2projectten from "../../../../public/projects/Lodha/images/projectten/gallery/2.webp";
import gallery3projectten from "../../../../public/projects/Lodha/images/projectten/gallery/3.webp";
import gallery4projectten from "../../../../public/projects/Lodha/images/projectten/gallery/4.webp";
import gallery5projectten from "../../../../public/projects/Lodha/images/projectten/gallery/5.webp";


export const developerLodha = {

  properties: [
    {
      name: "Lodha Giardino ",
      image: giardino,
      price: "On Request",
      state: "Pune",
      developer: "Lodha",
      projectlocation: "East Pune",
      location: "Kharadi, Pune",
      bed: " 3 - 4 BHK ",
      size: "1200 - 2148 sq. ft.",
      url: `/lodha-giardino-kharadi-pune`,
      form: {
        source_id: 11,
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      }
    },
    // {
    //   name: "Lodha Divino",
    //   image: divino,
    //   price: "On Request",
    //   state: "Mumbai",
    //   developer: "Lodha",
    //   location: "Matunga, Mumbai",
    //   projectlocation: "South Mumbai",
    //   bed: "2 - 3 - 3.5 BHK Apartments",
    //   size: "....",
    //   url: ``,
    //   form: {
    //     source_id: 11,
    //     api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
    //     api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
    //     sub_source_id: 130,
    //     builder_id: `103`,
    //     project_id: `477`,
    //     subject: "M3M Altitude", // Add or update the subject here
    //     to_email: "jatin.rohilla@propertystation.in",
    //   }
    // },

    {
      name: "Lodha Hosa Road ",
      image: bannerDesktopImagehosaroad,
      price: " 2.31 Cr Onwards",
      state: "Bangalore",
      developer: "Lodha",
      projectlocation: "East Pune",
      location: "Hosa Road, Kudlu Gate, Bangalore",
      bed: " 3 - 4 BHK ",
      size: "1050 - 2250 sq. ft.",
      url: `/lodha-hosa-road`,
      form: {
        source_id: 11,
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      }
    }


  ],
};
export const Headers = {
  logo: logo,
  data: {
    experience: "1980",
  },
  about: `Lodha has been redefining luxury living and influencing lifestyles with some of the best developments in the world for more than 40 years. They construct stunning settings where every element reflects an enhanced lifestyle, not simply houses. Their developments skillfully combine excellent design, painstaking attention to detail, and unmatched service, whether they are meticulously planned homes or business spaces.
`,
};

export const projectslodha = {
  lodha_divino: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImage_lodha_divino,
      bannerMobileImage: bannerMobileImage_lodha_divino,
      textOverlay: "",
      data: {
        title: "Lodha  Divino           ",
        subtitle: "Matunga, Mumbai",
        starting_price: "On Request",
        payment_plan: "CLP",
        rerano: "P51900049433",
        status: "Under Construction"
      }
    },
    overview: {
      heading: "Discover Luxury Living at Lodha  Divino Matunga",
      description: [
        "Lodha Divino Matunga, an upcoming residential masterpiece in Mumbai, offers elegantly designed 2, 3, and 4 BHK apartments in sophisticated high-rise towers. Nestled in the prime locality of Matunga, this development blends modern architecture with luxury, creating a serene retreat for residents. Each home is thoughtfully crafted with premium interiors and world-class amenities, ensuring a refined living experience. ",
        "With seamless connectivity and a vibrant neighborhood, Lodha Divino Matunga promises a lifestyle of comfort and exclusivity, making it the perfect choice for those seeking elegance, convenience, and tranquility in the heart of the city.",
      ],
      image: overviewImage_lodha_divino,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationicon_lodha_divino,
          title: "On Request ",
          subtitle: "Starting Price",
        },
        {
          iconClass: calicon_lodha_divino,
          title: "CLP",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchicon_lodha_divino,
          title: "Under Construction",
          subtitle: "Status",
        },
      ],
    },

    sitevisit: {
      image: siteVisitBannerImage_lodha_divino,
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "2 BHK ",
          area: "858 sq. ft.",
          price: "On Request*",
          eoiAmount: "On Request",
        },
        {
          type: "2 BHK + Study ",
          area: "920 sq. ft.",
          price: "On Request*",
          eoiAmount: "On Request",
        },
        {
          type: "3 BHK ",
          area: "1287 sq. ft.",
          price: "On Request*",
          eoiAmount: "On Request",
        },
        {
          type: "3 BHK + Study ",
          area: "1367 sq. ft.",
          price: "On Request*",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK ",
          area: "1680 sq. ft.",
          price: "On Request*",
          eoiAmount: "On Request",
        },

      ],
    },

    floor_plan: [
      {
        type: "2 BHK ",
        area: "858 sq. ft.",
        price: "On Request*",
        image: floorplan1_lodha_divino,
      },
      {
        type: "2 BHK + Study ",
        area: "920 sq. ft.",
        price: "On Request*",
        image: floorplan2_lodha_divino,
      },
      {
        type: "3 BHK ",
        area: "1287 sq. ft.",
        price: "On Request*",
        image: floorplan3_lodha_divino,
      },
      {
        type: "3 BHK + Study ",
        area: "1367 sq. ft.",
        price: "On Request*",
        image: floorplan4_lodha_divino,
      },
      {
        type: "4 BHK  ",
        area: "1680 sq. ft.",
        price: "On Request*",
        image: floorplan4_lodha_divino,
      },

    ],

    highlights: {
      images: Hightlights_lodha_divino,
      tagline: "Highlights",
      features: [
        "Experience divine living in Lodha Divino with a serene Jain temple .",
        "Flexible payment plan of 25:25:25:25 or 30:70 available.",
        "Located in the heart of Central Mumbai.",
        "Be a part of an exclusive and elite community.",
        "Beautiful conjunction of Residential and Commercial property.",
      ],
    },

    location: {
      image: Location_lodha_divino,
      data: [
        {
          airport: {
            distance_time: "13 km",
            name: "Mumbai Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "T I School"
          },
          railwayormetro: {
            distance_time: "2 Km",
            name: "GTB Nagar"
          },
          hospital: {
            distance_time: "1 Km",
            name: "S M Hospital"
          },
          mall: {
            distance_time: "1 Km",
            name: "Star City"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1_lodha_divino },
        { image: gallery2_lodha_divino },
        { image: gallery3_lodha_divino },
        { image: gallery4_lodha_divino },
        { image: gallery5_lodha_divino },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in Lodha  Divino Matunga, kindly share more details.",
    },

    faq: [
      {
        question: "What is Lodha Divino?",
        answer: `Lodha Divino is a luxury residential project by Lodha Group in Matunga, Mumbai, offering spacious 2, 3, and 4 BHK apartments with world-class amenities.`,
      },
      {
        question: "Where is Lodha Divino located?",
        answer: `Lodha Divino is strategically located in Matunga, Mumbai, providing excellent connectivity to key business hubs, entertainment zones, and transport facilities.`,
      },
      {
        question: "What types of apartments are available at Lodha Divino?",
        answer: `The project offers 2 BHK, 3 BHK, and 4 BHK luxury apartments with premium interiors, spacious layouts, and modern amenities.`,
      },
      {
        question: "What are the key amenities at Lodha Divino?",
        answer: `Lodha Divino offers top-notch amenities, including a grand clubhouse, swimming pool, landscaped gardens, fitness center, kids’ play area, jogging track, and 24/7 security.`,
      },
      {
        question: "Who is the developer of Lodha Divino??",
        answer: `Lodha Divino is developed by Lodha Group, one of India's most reputed real estate developers known for delivering high-quality luxury residences.`,
      },
      {
        question: "Is Lodha Divino RERA registered?",
        answer: `Yes, Lodha Divino is RERA registered, ensuring transparency and compliance with all regulatory requirements.`,
      },
      {
        question: "What is the starting price of apartments in Lodha Divino?",
        answer: `The starting price of apartments at Lodha Divino from ₹3.21 crore.`,
      },
      {
        question: "Does Lodha Divino offer any payment plans or financing options?",
        answer: `Yes, Lodha Divino provides flexible payment plans and home loan assistance in collaboration with leading banks.`,
      },
      {
        question: "What is the expected possession date of Lodha Divino??",
        answer: `The expected possession date for Lodha Divino is December 2027.`,
      },
      {
        question: "What makes Lodha Divino a prime investment option in Mumbai?",
        answer: `Lodha Divino is a prime investment due to its strategic location, luxurious design, world-class amenities, and strong appreciation potential in the Mumbai real estate market.`,
      },
    ],

    similar: {
      properties: [
        {
          name: "Lodha Giardino ",
          image: giardino,
          price: "On Request",
          state: "Pune",
          developer: "Lodha",
          projectlocation: "East Pune",
          location: "Kharadi, Pune",
          bed: "2 - 3 - 4 BHK ",
          size: "....",
          url: `/lodha-giardino-kharadi-pune`,
          form: {
            source_id: 11,
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "M3M Altitude", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          }
        },
        {
          name: "Lodha Divino",
          image: divino,
          price: "On Request",
          state: "Mumbai",
          developer: "Lodha",
          location: "Matunga, Mumbai",
          projectlocation: "South Mumbai",
          bed: "2 - 3 - 3.5 BHK Apartments",
          size: "....",
          url: `/lodha-divino-matunga-mumbai`,
          form: {
            source_id: 11,
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "M3M Altitude", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          }
        },


      ],
    },
    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },

  },

  lodha_giardino: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImage_giardino,
      bannerMobileImage: bannerMobileImage_giardino,
      textOverlay: "",
      data: {
        title: "Lodha Giardino",
        subtitle: "Kharadi, Pune",
        starting_price: "On Request",
        payment_plan: "CLP",
        rerano: "P52100047587",
        status: "Under Construction"
      }
    },
    overview: {
      heading: "Discover Luxury Living at Lodha Giardino ",
      description: [
        "Lodha Giardino, a newly launched cluster within the prestigious Lodha Estilo in Kharadi, Pune, offers an exclusive collection of 3 BHK spacious residences, along with luxurious 3 and 4 BHK penthouses. Designed for elegance and comfort, this low-density tower features only four units per floor, ensuring privacy and tranquility. Expansive decks, open gardens, and two-side open living spaces provide ample ventilation and natural light.",
        "Residents enjoy world-class amenities, including an 18,000 sq. ft. clubhouse, infinity pool, indoor games, hi-tech gym, spa, futsal court, outdoor workspaces, library, organic garden, and a serene Ganesh temple, redefining modern luxury living.",
      ],
      image: overviewImage_giardino,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationicon_giardino,
          title: "On Request ",
          subtitle: "Starting Price",
        },
        {
          iconClass: calicon_giardino,
          title: "CLP",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchicon_giardino,
          title: "Under Construction",
          subtitle: "Status",
        },
      ],
    },

    sitevisit: {
      image: siteVisitBannerImage_giardino,
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "1200 sq. ft.",
          price: "On Request*",
          eoiAmount: "On Request",
        },
        {
          type: "Penthouses ",
          area: "1750 sq. ft.",
          price: "On Request*",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK ",
          area: "2148 sq. ft.",
          price: "On Request*",
          eoiAmount: "On Request",
        },

      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "1200 sq. ft.",
        price: "On Request*",
        image: floorplan1_giardino,
      },
      {
        type: "Penthouses ",
        area: "1750 sq. ft.",
        price: "On Request*",
        image: floorplan2_giardino,
      },
      {
        type: "4 BHK ",
        area: "2148 sq. ft.",
        price: "On Request*",
        image: floorplan3_giardino,
      },


    ],

    highlights: {
      images: Hightlights_giardino,
      tagline: "Highlights",
      features: [
        "Bespoke Amenities with Grand Clubhouse (~18000 sf) and Roof top Amenities (~43000 sf).",
        "L Shaped premium living spaces ~ 400 sf area.",
        "L Shaped premium living spaces ~ 400 sf area.",
        "Architecture by Christopher Charles Benninger & Associates.",
        "⁠Lush green vegetated Landscape, designed by world renowned design house - Sitetectonix.",
      ],
    },

    location: {
      image: Location_giardino,
      data: [
        {
          airport: {
            distance_time: "7 km",
            name: "Pune Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "NCH School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Hadapsar"
          },
          hospital: {
            distance_time: "3 Km",
            name: "K K Hospital"
          },
          mall: {
            distance_time: "3 Km",
            name: "Reliance Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1_giardino },
        { image: gallery2_giardino },
        { image: gallery3_giardino },
        { image: gallery4_giardino },
        { image: gallery5_giardino },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "",
      welcomeMessage:
        "Hi! I'm interested in Lodha Giardino , kindly share more details.",
    },

    faq: [

      {
        question: "Where is Lodha Giardino located?",
        answer: `Lodha Giardino is situated in Kharadi, Pune, a prime residential and IT hub with excellent connectivity to major business centers, educational institutions, and healthcare facilities.`,
      },
      {
        question: "What are the available configurations in Lodha Giardino?",
        answer: `The project offers 2 BHK, 3 BHK, and 4 BHK apartments, designed to provide a luxurious and comfortable lifestyle.`,
      },
      {
        question: "What is the starting price of apartments in Lodha Giardino?",
        answer: `The starting price for apartments in Lodha Giardino is approximately ₹1.10 Crore onwards. The price varies based on the configuration and unit size.`,
      },
      {
        question: "Is Lodha Giardino RERA-approved?",
        answer: `Yes, Lodha Giardino is RERA-approved, ensuring transparency and compliance with regulatory standards. The RERA registration number can be verified on the official website.`,
      },
      {
        question: "Who is the developer of Lodha Giardino?",
        answer: `Lodha Giardino is developed by Lodha Group, one of India’s leading real estate developers known for high-quality residential and commercial projects.`,
      },
      {
        question: "What is the total area of the Lodha Giardino project?",
        answer: `Lodha Giardino is spread across 14 acres, offering a vast green landscape and open spaces for a serene living experience.`,
      },
      {
        question: "What makes Lodha Giardino a standout choice for homebuyers?",
        answer: `Lodha Giardino in Kharadi, Pune, stands out as a premier residential choice for homebuyers seeking luxury, comfort, and a nature-inspired lifestyle. `,
      },
      {
        question: "What is the construction status of Lodha Giardino?",
        answer: `LLodha Giardino is currently under construction, with possession expected in the coming years as per the project timeline. `,
      },
      {
        question: "Is Lodha Giardino a good investment option?",
        answer: `Yes, Kharadi is a high-growth area with rising property values due to its IT hubs and infrastructure development, making Lodha Giardino an excellent investment opportunity.`,
      },
      {
        question: "What security features are available at Lodha Giardino?",
        answer: `The project includes 24/7 CCTV surveillance, gated community access, and trained security personnel. Residents can enjoy a safe and secure living environment at Lodha Giardino.`,
      },
    ],

    similar: {
      properties: [
        {
          name: "Lodha Giardino ",
          image: giardino,
          price: "On Request",
          state: "Pune",
          developer: "Lodha",
          projectlocation: "East Pune",
          location: "Kharadi, Pune",
          bed: "2 - 3 - 4 BHK ",
          size: "....",
          url: `/lodha-giardino-kharadi-pune`,
          form: {
            source_id: 11,
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "M3M Altitude", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          }
        },
        {
          name: "Lodha Divino",
          image: divino,
          price: "On Request",
          state: "Mumbai",
          developer: "Lodha",
          location: "Matunga, Mumbai",
          projectlocation: "South Mumbai",
          bed: "2 - 3 - 3.5 BHK Apartments",
          size: "....",
          url: ``,
          form: {
            source_id: 11,
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "M3M Altitude", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          }
        },


      ],
    },
    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },

  },
  hosaroad: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImagehosaroad,
      bannerMobileImage: bannerMobileImagehosaroad,
      textOverlay: "",
      data: {
        title: "Lodha Hosa Road South Bangalore",
        subtitle: "Hosa Road, Kudlu Gate, Bangalore",
        starting_price: "₹ 2.31 Cr Onwards",
        payment_plan: "CLP",
        rerano: "Coming Soon",
        status: "New Launch",
      },
    },
    overview: {
      heading: "Lodha Hosa Road South Bangalore",
      description: [
        "Lodha Hosa Road in South Bangalore stands out as a premier residential destination, seamlessly blending luxury, connectivity, and convenience in one of the city’s fastest-growing corridors. Strategically located near major IT hubs like Electronic City, Sarjapur Road, and HSR Layout, this address is highly sought after by professionals and families seeking easy access to workspaces, reputed schools, and top healthcare facilities. The upcoming Lodha project on Hosa Road offers a range of premium 3 and 4 BHK apartments, with spacious layouts, contemporary designs, and world-class amenities such as landscaped gardens, fitness centers, swimming pools, and 24/7 security, ensuring a comfortable and secure lifestyle for residents.",
        "Connectivity is a major highlight, with the Hosa Road Metro Station just minutes away and quick access to arterial roads like Outer Ring Road and Hosur Road, making daily commutes hassle-free. The neighborhood is surrounded by essential conveniences, including shopping malls, fine dining restaurants, and entertainment zones, catering to a vibrant urban lifestyle. Healthcare needs are well-served by renowned hospitals such as Manipal Hospital and Narayana Multi-Specialty Hospital, both within a 15-minute drive. For families, proximity to prestigious educational institutions like The Cambridge International School and Gear International School ensures quality education for children.",
        "Lodha Hosa Road’s real estate value is further enhanced by robust infrastructure development and the reputation of the Lodha Group, making it not only an excellent place to live but also a smart investment choice with strong appreciation potential. With competitive pricing and flexible payment plans, Lodha Hosa Road is attracting discerning buyers looking for a blend of luxury, location, and long-term value in South Bangalore’s dynamic property market",

      ],
      keywordLinks: {

      },
      image: overviewImagehosaroad,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconhosaroad,
          title: "₹ 2.3 Cr Onwards",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconhosaroad,
          title: "New Launch",
          subtitle: "Status",
        },
        {
          iconClass: newlaunchiconhosaroad,
          title: "Under Construction",
          subtitle: " Status",
        },
      ],
    },



    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK",
          area: "1050 sq. ft.",
          price: "₹ 2.31 Cr Onwards",
          eoiAmount: "On Request",
        },
        {
          type: "3.5 BHK",
          area: "1300 sq. ft.",
          price: "₹ 2.91 Cr Onwards",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK",
          area: "2250 sq. ft.",
          price: "₹ 4.79 Cr Onwards",
          eoiAmount: "On Request",
        },

      ],
    },

    floor_plan: [
      {
        type: "3 BHK",
        area: "1050 sq. ft.",
        price: "₹ 2.31 Cr Onwards",
        image: floorplan1hosaroad,
      },
      {
        type: "3.5 BHK",
        area: "1300 sq. ft.",
        price: "₹ 2.91 Cr Onwards",
        image: floorplan2hosaroad,
      },
      {
        type: "4 BHK",
        area: "2250 sq. ft.",
        price: "₹ 4.79 Cr Onwards",
        image: floorplan3hosaroad,
      },


    ],

    highlights: {
      images: Hightlightshosaroad,
      tagline: "Highlights",
      features: [
        "Over 40 Premium Amenities  ",
        "Scenic Lake Views  ",
        "Central Greens Inspired by Forest Themes  ",
        "10 Minutes from Sarjapur Road & Hosur Road  ",
        "Located at Hosa Road - Kudlu Gate",
        "15 Minutes to Hosa Road Metro Station ",
      ],
    },

    location: {
      image: Locationhosaroad,
      data: [
        {
          airport: {
            distance_time: "- km",
            name: "Airport",
          },
          school: {
            distance_time: "2.5 Km",
            name: "Oxford School",
          },
          railwayormetro: {
            distance_time: "10.2 m",
            name: "Jayanagar Metro Station   ",
          },
          hospital: {
            distance_time: "1.2 Km",
            name: "Narayana Hospital",
          },
          mall: {
            distance_time: "- Km",
            name: "Nexus Mall Koramangala",
          },
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1hosaroad },
        { image: gallery2hosaroad },
        { image: gallery3hosaroad },
        { image: gallery4hosaroad },
        { image: gallery5hosaroad },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "",
      welcomeMessage:
        "Hi! I'm interested in Lodha Hosa, kindly share more details.",
    },

    faq: [
      {
        question: "What type of apartments are available in Lodha Hosa Road?",
        answer: "Lodha Hosa Road offers spacious and well-designed 2, 3, and 4 BHK apartments.",
      },
      {
        question: "Where is Lodha Hosa Road located in Bangalore?",
        answer: "The project is strategically located on Hosa Road, South Bangalore.",
      },
      {
        question: "What amenities are available at Lodha Hosa Road South Bangalore?",
        answer: "The project offers a range of world-class amenities including a clubhouse, swimming pool, gymnasium.",
      },
      {
        question: "Who is the developer of Lodha Hosa Road project?",
        answer: "The project is developed by the prestigious Lodha Group.",
      },
      {
        question: "What is the possession date of Lodha Hosa Road South Bangalore apartments?",
        answer: "The possession timeline for Lodha Hosa Road apartments is expected to be announced soon.",
      },
      {
        question: "Is Lodha Hosa Road RERA approved?",
        answer: "Yes, the project is RERA registered, ensuring transparency and legal compliance.",
      },
      {
        question: "How well-connected is Lodha Hosa Road to key areas in Bangalore?",
        answer: "The project enjoys excellent connectivity to Electronic City, Silk Board, and Koramangala.",
      },
      {
        question: "What is the pricing of apartments in Lodha Hosa Road?",
        answer: "The pricing details vary based on the configuration. 3 BHK apartments are available from ₹2.3 Crore and 4 BHK apartments from ₹4.7 Crore.",
      },
      {
        question: "Are there any schools, hospitals, or shopping centers near Lodha Hosa Road?",
        answer: "Yes, the project is surrounded by reputed schools like Orchids International, hospitals like Narayana Hrudayalaya, and malls like Forum and Market Square.",
      },
      {
        question: "What makes Lodha Hosa Road Bangalore a good investment option?",
        answer: "With its prime location, branded developer, luxurious amenities, and proximity to tech parks, Lodha Hosa Road is a promising investment choice.",
      },
    ],

    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },

  },
  panache: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImagepanache,
      bannerMobileImage: bannerMobileImagepanache,
      textOverlay: "",
      data: {
        title: "Lodha Panache",
        subtitle: "Hinjewadi, Pune",
        starting_price: "₹ 92.23 L - 5.9 Cr Onwards",
        payment_plan: "Flexible Payment Plans",
        rerano: "P52100050124",
        status: "New Launch"
      }
    },

    overview: {
      heading: "Lodha Panache Hinjewadi, Pune",
      description: [
        "Lodha Panache Hinjewadi Pune is a top project in Hinjewadi Pune, offering luxury and comfort in a great location for homebuyers. It is located in Hinjewadi Phase 1, a popular area for both work and living, making it perfect for professionals and families looking for flats in Pune Hinjewadi. The project has well-designed 2 BHK flats, as well as larger 3 and 4 BHK options, catering to different needs and lifestyles.",
        "Residents can enjoy a high-quality lifestyle with over 70% open space, beautiful gardens, and many amenities. A large clubhouse, swimming pool, sports courts, children's play area, and peaceful gardens provide a calm setting in the busy city. Each 2 BHK flat is designed for maximum space, with marble floors, air-conditioned bedrooms, and big windows for natural light. Living rooms connect to large balconies for relaxation and entertainment.",
        "Lodha Panache has great connectivity. It has easy access to the Mumbai-Pune Expressway, Pune-Bangalore Highway, and the upcoming Pune Metro, making it easy to reach business and entertainment areas in Pune. Being close to IT parks, good schools, hospitals, and shopping centers adds to the convenience of living here.",
        "The price for 2 BHK flats in Pune Hinjewadi at Lodha Panache starts at around ₹92 lakh, reflecting its quality and lifestyle. Possession is expected from December 2025 to January 2026, giving buyers a chance to own a home in a rapidly growing area of Pune. Whether you need a modern home for your family or a smart investment, Lodha Panache offers a great mix of luxury, location, and top-notch amenities.",
      ],
      keywordLinks: {
      },
      image: overviewImagepanache,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconpanache,
          title: "₹ 92.23 L Onwards",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconpanache,
          title: "CLP",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconpanache,
          title: "New Launch",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "2 BHK",
          area: "700 - 908 sq.ft.",
          price: "₹ 92.23 L - 1.2 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "3 BHK",
          area: "1121 - 2900 sq.ft.",
          price: "₹ 1.46 - 3.78 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK",
          area: "1400 - 3800 sq.ft.",
          price: "₹ 2.52 - 5.9 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "5 BHK",
          area: "2249 - 2271 sq.ft.",
          price: "₹ 4.16 - 4.2 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "2 BHK",
        area: "700 - 908 sq.ft.",
        price: "₹ 92.23 L - 1.2 Cr",
        image: floorplan1panache,
      },
      {
        type: "3 BHK",
        area: "1121 - 2900 sq.ft.",
        price: "₹ 1.46 - 3.78 Cr",
        image: floorplan2panache,
      },
      {
        type: "4 BHK",
        area: "1400 - 3800 sq.ft.",
        price: "₹ 2.52 - 5.9 Cr",
        image: floorplan3panache,
      },
      {
        type: "5 BHK",
        area: "2249 - 2271 sq.ft.",
        price: "₹ 4.16 - 4.2 Cr",
        image: floorplan4panache,
      }
    ],

    highlights: {
      images: Hightlightspanache,
      tagline: "Highlights",
      features: [
        "70% of the area is open space",
        "Club Infinity covers over 20,000 square feet",
        "Sky Sports Club is 100 meters above ground",
        "5-a-side football field with separate practice area",
        "Fruit orchard within the premises",
        "Dedicated garden area for working from home",
        "Located inside Blue Ridge Township",
      ],
    },

    location: {
      image: Locationpanache,
      data: [
        {
          airport: {
            distance_time: "23.9 km",
            name: "Pune International Airport"
          },
          school: {
            distance_time: "6.3 km",
            name: "NICMAR University"
          },
          railwayormetro: {
            distance_time: "10.1 km",
            name: "Chinchwad Railway Station"
          },
          hospital: {
            distance_time: "1.7 km",
            name: "LifeTree Hospital"
          },
          mall: {
            distance_time: "1.8 km",
            name: "Xion Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1panache },
        { image: gallery2panache },
        { image: gallery3panache },
        { image: gallery4panache },
        { image: gallery5panache },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in Lodha Panache Hinjewadi, kindly share more details.",
    },

    faq: [
      {
        question: "What is the possession timeline for Lodha Panache?",
        answer: `Possession for the apartments is expected by December 2025 to January 2026.`
      },
      {
        question: "What types of residences are available at Lodha Panache?",
        answer: `The project offers 2 BHK, 3 BHK, 4 BHK, and 5 BHK flats.`
      },
      {
        question: "What are the key amenities offered at Lodha Panache?",
        answer: `Residents enjoy a 20,000 sq. ft. clubhouse, swimming pool, gym, indoor games, badminton courts, and more.`
      },
      {
        question: "Is Lodha Panache a gated community?",
        answer: `Yes, it is a gated community with 24/7 security and CCTV surveillance.`
      },
      {
        question: "How much open space does the project provide?",
        answer: `Lodha Panache features over 70% open spaces, including lush gardens and lawns.`
      },
      {
        question: "What is the starting price for 2 BHK and 3 BHK flats?",
        answer: `The price for a 2 BHK flat starts at approximately ₹92 lakh, while 3 BHK flats are priced from ₹1.46 crore.`
      },
      {
        question: "How is Lodha Panache connected to the rest of Pune?",
        answer: `The project is well-connected via the Mumbai-Pune Expressway and Pune-Bangalore Highway, with easy access to the upcoming Pune Metro.`
      },
      {
        question: "Who is the developer behind Lodha Panache?",
        answer: `Lodha Panache is developed by Lodha Group.`
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, Lodha Panache is RERA registered with the number P52100050124.`
      },
      {
        question: "Are there any special lifestyle features?",
        answer: `Unique features include a sky terrace and bar, pet park, Ganesh temple, and organic gardens.`
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  magnus: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImagemagnus,
      bannerMobileImage: bannerMobileImagemagnus,
      textOverlay: "",
      data: {
        title: "Lodha Magnus",
        subtitle: "Hinjewadi, Pune",
        starting_price: "₹ 1.97 - 2.8 Crore Onwards",
        payment_plan: "Flexible Payment Plans Available",
        rerano: "P52100000647",
        status: "Under Construction"
      }
    },

    overview: {
      heading: "Lodha Magnus Hinjewadi, Pune",
      description: [
        "Lodha Magnus Hinjewadi Pune is a top choice for people looking for luxury homes in Pune's IT area. Built by the well-known Lodha Group, this project offers well-designed apartments and great facilities. While it mainly has large 3 and 4 BHK homes, there is also a high demand for 2 BHK flats because of the area's closeness to major IT parks, schools, and daily services.",
        "For those looking for flats in Pune Hinjewadi, the area has good infrastructure, easy travel options, and a lively community. The apartments in Hinjewadi are especially popular with young workers and families who want convenience and a good lifestyle. The region is known for its safe gated communities and various living options, including high-end projects like Lodha Magnus.",
        "Lodha Magnus is well-placed, making it easy to access the Rajiv Gandhi IT Park, the Mumbai-Bangalore Highway, and daily needs. Residents can enjoy many amenities like a large clubhouse, a sky bar, beautiful gardens, and strong security, ensuring a comfortable and safe living space. The design features large rooms, big balconies, and tall windows with great city views, setting a new standard for apartments in Hinjewadi.",
        "While there are many 2 BHK flats available in other projects, Lodha Magnus aims to provide a more luxurious lifestyle with its bigger homes. However, Hinjewadi has a variety of 2 BHK options, usually between 700 to 950 sq.ft., starting around ₹70 lakh, making them affordable for many buyers. These flats meet modern needs with good layouts and access to high-quality facilities.",
        "Choosing Lodha Magnus Hinjewadi Pune or any good 2 BHK flats in the area is a smart investment in a growing neighborhood with great future potential. Whether you want a luxurious home or a wise investment, Hinjewadi Pune apartments offer a perfect mix of comfort, good transport, and modern living, making it one of Pune's best places to live."
      ],
      keywordLinks: {
        "Lodha Group": "/developers/lodha-group",
      },
      image: overviewImagemagnus,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconmagnus,
          title: "₹ 1.97 - 2.8 Cr Onwards",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconmagnus,
          title: "Flexible Plans",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconmagnus,
          title: "Under Construction",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK",
        area: "1269.6 - 1388 sq.ft.",
        price: "₹ 1.97 - 2.15 Cr",
        image: floorplan1magnus,
      },
      {
        type: "4 BHK",
        area: "1784.87 - 1942 sq.ft.",
        price: "₹ 2.57 - 2.8 Cr",
        image: floorplan2magnus,
      }
    ],

    highlights: {
      images: Hightlightsmagnus,
      tagline: "Highlights",
      features: [
        "Great Location with Easy Access to Work: Located in Hinjewadi Phase 1, just 10 minutes away from over 170 top companies.",
        "Sky Bar & Terrace: A peaceful place for social events and relaxation.",
        "Large Living Rooms: Spacious decks with a stunning view of the Sahyadri hills, offering the biggest homes nearby.",
        "Sky Sports Club: Positioned 100 feet above the ground.",
        "Top-Notch Amenities: A lovely garden with colorful flowers, green lawns, walking paths, a play area for kids, and a small swimming pool.",
        "Premium Location: Close to IT parks, educational institutions, and healthcare facilities.",
        "Modern Design: Features large rooms, big balconies, and tall windows with great city views.",
      ],
    },

    location: {
      image: Locationmagnus,
      data: [
        {
          airport: {
            distance_time: "6 km",
            name: "Pune International Airport"
          },
          school: {
            distance_time: "900 m",
            name: "Bliss International School"
          },
          railwayormetro: {
            distance_time: "10.1 km",
            name: "Hinjewadi Metro Station"
          },
          hospital: {
            distance_time: "1.7 km",
            name: "Hinjewadi Hospital"
          },
          mall: {
            distance_time: "4.8 km",
            name: "Phoenix Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1magnus },
        { image: gallery2magnus },
        { image: gallery3magnus },
        { image: gallery4magnus },
        { image: gallery5magnus },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in Lodha/images The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is Lodha/images The Trillion located?",
        answer: `Lodha/images The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at Lodha/images The Trillion?",
        answer: `Lodha/images The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in Lodha/images The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at Lodha/images The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, Lodha/images The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of Lodha/images The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at Lodha/images The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of Lodha/images The Trillion?",
        answer: `Lodha/images The Trillion is developed by Lodha/images Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is Lodha/images The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, Lodha/images The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from Lodha/images The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectthree: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectthree,
      bannerMobileImage: bannerMobileImageprojectthree,
      textOverlay: "",
      data: {
        title: "Lodha/images The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "Lodha/images The Trillion",
      description: [
        "Lodha/images The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by Lodha/images Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at Lodha/images Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at Lodha/images Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of Lodha/images The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "Lodha/images": "/developers/Lodha/images",
      },
      image: overviewImageprojectthree,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectthree,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojectthree,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojectthree,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectthree,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectthree,
      }
    ],

    highlights: {
      images: Hightlightsprojectthree,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectthree,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectthree },
        { image: gallery2projectthree },
        { image: gallery3projectthree },
        { image: gallery4projectthree },
        { image: gallery5projectthree },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in Lodha/images The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is Lodha/images The Trillion located?",
        answer: `Lodha/images The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at Lodha/images The Trillion?",
        answer: `Lodha/images The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in Lodha/images The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at Lodha/images The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, Lodha/images The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of Lodha/images The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at Lodha/images The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of Lodha/images The Trillion?",
        answer: `Lodha/images The Trillion is developed by Lodha/images Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is Lodha/images The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, Lodha/images The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from Lodha/images The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectfour: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectfour,
      bannerMobileImage: bannerMobileImageprojectfour,
      textOverlay: "",
      data: {
        title: "Lodha/images The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "Lodha/images The Trillion",
      description: [
        "Lodha/images The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by Lodha/images Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at Lodha/images Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at Lodha/images Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of Lodha/images The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "Lodha/images": "/developers/Lodha/images",
      },
      image: overviewImageprojectfour,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectfour,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojectfour,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojectfour,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectfour,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectfour,
      }
    ],

    highlights: {
      images: Hightlightsprojectfour,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectfour,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectfour },
        { image: gallery2projectfour },
        { image: gallery3projectfour },
        { image: gallery4projectfour },
        { image: gallery5projectfour },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in Lodha/images The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is Lodha/images The Trillion located?",
        answer: `Lodha/images The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at Lodha/images The Trillion?",
        answer: `Lodha/images The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in Lodha/images The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at Lodha/images The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, Lodha/images The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of Lodha/images The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at Lodha/images The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of Lodha/images The Trillion?",
        answer: `Lodha/images The Trillion is developed by Lodha/images Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is Lodha/images The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, Lodha/images The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from Lodha/images The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectfive: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectfive,
      bannerMobileImage: bannerMobileImageprojectfive,
      textOverlay: "",
      data: {
        title: "Lodha/images The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "Lodha/images The Trillion",
      description: [
        "Lodha/images The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by Lodha/images Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at Lodha/images Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at Lodha/images Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of Lodha/images The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "Lodha/images": "/developers/Lodha/images",
      },
      image: overviewImageprojectfive,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectfive,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojectfive,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojectfive,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectfive,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectfive,
      }
    ],

    highlights: {
      images: Hightlightsprojectfive,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectfive,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectfive },
        { image: gallery2projectfive },
        { image: gallery3projectfive },
        { image: gallery4projectfive },
        { image: gallery5projectfive },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in Lodha/images The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is Lodha/images The Trillion located?",
        answer: `Lodha/images The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at Lodha/images The Trillion?",
        answer: `Lodha/images The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in Lodha/images The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at Lodha/images The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, Lodha/images The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of Lodha/images The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at Lodha/images The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of Lodha/images The Trillion?",
        answer: `Lodha/images The Trillion is developed by Lodha/images Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is Lodha/images The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, Lodha/images The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from Lodha/images The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectsix: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectsix,
      bannerMobileImage: bannerMobileImageprojectsix,
      textOverlay: "",
      data: {
        title: "Lodha/images The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "Lodha/images The Trillion",
      description: [
        "Lodha/images The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by Lodha/images Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at Lodha/images Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at Lodha/images Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of Lodha/images The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "Lodha/images": "/developers/Lodha/images",
      },
      image: overviewImageprojectsix,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectsix,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojectsix,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojectsix,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectsix,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectsix,
      }
    ],

    highlights: {
      images: Hightlightsprojectsix,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectsix,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectsix },
        { image: gallery2projectsix },
        { image: gallery3projectsix },
        { image: gallery4projectsix },
        { image: gallery5projectsix },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in Lodha/images The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is Lodha/images The Trillion located?",
        answer: `Lodha/images The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at Lodha/images The Trillion?",
        answer: `Lodha/images The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in Lodha/images The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at Lodha/images The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, Lodha/images The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of Lodha/images The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at Lodha/images The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of Lodha/images The Trillion?",
        answer: `Lodha/images The Trillion is developed by Lodha/images Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is Lodha/images The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, Lodha/images The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from Lodha/images The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectseven: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectseven,
      bannerMobileImage: bannerMobileImageprojectseven,
      textOverlay: "",
      data: {
        title: "Lodha/images The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "Lodha/images The Trillion",
      description: [
        "Lodha/images The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by Lodha/images Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at Lodha/images Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at Lodha/images Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of Lodha/images The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "Lodha/images": "/developers/Lodha/images",
      },
      image: overviewImageprojectseven,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectseven,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojectseven,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojectseven,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectseven,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectseven,
      }
    ],

    highlights: {
      images: Hightlightsprojectseven,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectseven,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectseven },
        { image: gallery2projectseven },
        { image: gallery3projectseven },
        { image: gallery4projectseven },
        { image: gallery5projectseven },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in Lodha/images The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is Lodha/images The Trillion located?",
        answer: `Lodha/images The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at Lodha/images The Trillion?",
        answer: `Lodha/images The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in Lodha/images The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at Lodha/images The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, Lodha/images The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of Lodha/images The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at Lodha/images The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of Lodha/images The Trillion?",
        answer: `Lodha/images The Trillion is developed by Lodha/images Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is Lodha/images The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, Lodha/images The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from Lodha/images The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projecteight: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojecteight,
      bannerMobileImage: bannerMobileImageprojecteight,
      textOverlay: "",
      data: {
        title: "Lodha/images The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "Lodha/images The Trillion",
      description: [
        "Lodha/images The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by Lodha/images Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at Lodha/images Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at Lodha/images Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of Lodha/images The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "Lodha/images": "/developers/Lodha/images",
      },
      image: overviewImageprojecteight,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojecteight,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojecteight,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojecteight,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projecteight,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projecteight,
      }
    ],

    highlights: {
      images: Hightlightsprojecteight,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojecteight,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projecteight },
        { image: gallery2projecteight },
        { image: gallery3projecteight },
        { image: gallery4projecteight },
        { image: gallery5projecteight },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in Lodha/images The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is Lodha/images The Trillion located?",
        answer: `Lodha/images The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at Lodha/images The Trillion?",
        answer: `Lodha/images The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in Lodha/images The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at Lodha/images The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, Lodha/images The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of Lodha/images The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at Lodha/images The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of Lodha/images The Trillion?",
        answer: `Lodha/images The Trillion is developed by Lodha/images Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is Lodha/images The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, Lodha/images The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from Lodha/images The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectnine: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectnine,
      bannerMobileImage: bannerMobileImageprojectnine,
      textOverlay: "",
      data: {
        title: "Lodha/images The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "Lodha/images The Trillion",
      description: [
        "Lodha/images The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by Lodha/images Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at Lodha/images Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at Lodha/images Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of Lodha/images The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "Lodha/images": "/developers/Lodha/images",
      },
      image: overviewImageprojectnine,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectnine,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojectnine,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojectnine,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectnine,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectnine,
      }
    ],

    highlights: {
      images: Hightlightsprojectnine,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectnine,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectnine },
        { image: gallery2projectnine },
        { image: gallery3projectnine },
        { image: gallery4projectnine },
        { image: gallery5projectnine },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in Lodha/images The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is Lodha/images The Trillion located?",
        answer: `Lodha/images The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at Lodha/images The Trillion?",
        answer: `Lodha/images The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in Lodha/images The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at Lodha/images The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, Lodha/images The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of Lodha/images The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at Lodha/images The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of Lodha/images The Trillion?",
        answer: `Lodha/images The Trillion is developed by Lodha/images Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is Lodha/images The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, Lodha/images The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from Lodha/images The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  projectten: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImageprojectten,
      bannerMobileImage: bannerMobileImageprojectten,
      textOverlay: "",
      data: {
        title: "Lodha/images The Trillion",
        subtitle: " Sector 48, Gurugram",
        starting_price: "₹ 6.14 Crore Onwards  ",
        payment_plan: "20:40:40",
        rerano: "GGM/911/643/2025/14",
        status: "New Launch"
      }
    },

    overview: {
      heading: "Lodha/images The Trillion",
      description: [
        "Lodha/images The Trillion in Gurgaon is a new luxury residential project that offers a stylish and comfortable lifestyle. This residential project is located in Sector 48, Golf Course Extension Road, this project is designed for people who want a modern home with top-class features. It is developed by Lodha/images Developers, The Trillion brings a perfect mix of beautiful design, world-class amenities, and a prime location.",
        "The project offers spacious 3 BHK, 4 BHK apartments, and penthouses with smart layouts and premium interiors. Every home at Lodha/images Trillion is made to give you more space, natural light, and a peaceful environment. High-quality materials, smart home features, and luxury fittings make each apartment truly special.",
        "Living at Lodha/images Trillion Sector 48 Gurgaon means enjoying a lot of premium facilities. There is a modern clubhouse, swimming pool, gym, spa, private dining spaces, children’s play area, and beautiful green gardens. You also get 24x7 security, concierge services, and easy access to all daily needs.",
        "The location of Lodha/images The Trillion is one of its biggest advantages. It is close to important offices, schools, hospitals, malls, and restaurants. Major roads like Golf Course Road, NH-8, and the Rapid Metro are nearby, making travel quick and easy.",
      ],
      keywordLinks: {
        "Lodha/images": "/developers/Lodha/images",
      },
      image: overviewImageprojectten,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconprojectten,
          title: "₹ 6.14 Crore Onwards ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconprojectten,
          title: "20:40:40",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconprojectten,
          title: "New Launch ",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "3000 sq.ft.",
          price: "₹ 6.14 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK  ",
          area: "3600 sq.ft. ",
          price: "₹ 7.37 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK ",
        area: "3000 sq.ft.",
        price: "₹ 6.14 Cr",
        image: floorplan1projectten,
      },
      {
        type: "4 BHK  ",
        area: "3600 sq.ft. ",
        price: "₹ 7.37 Cr",
        image: floorplan2projectten,
      }
    ],

    highlights: {
      images: Hightlightsprojectten,
      tagline: "Highlights",
      features: [
        "540 EXCLUSIVE Units. ",
        "Over 80% of green space. ",
        "Stilt + 45 Storey Towers. ",
        "VRV / VRF Air-Conditioning & Modular Kitche. ",
        "Basement Entrance Lobby with Green Atrium. ",
        "Two Car Parkings Per Unit. ",
        "Over 1 lakh sq. ft. of amenities space. ",
      ],
    },

    location: {
      image: Locationprojectten,
      data: [
        {
          airport: {
            distance_time: "24 km",
            name: "IGI Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "GD Goenka School"
          },
          railwayormetro: {
            distance_time: "6 Km",
            name: "Millennium City Centre Gurugram"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Park Hospital"
          },
          mall: {
            distance_time: "7 Km",
            name: "Airia Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1projectten },
        { image: gallery2projectten },
        { image: gallery3projectten },
        { image: gallery4projectten },
        { image: gallery5projectten },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in Lodha/images The Trillion, kindly share more details.",
    },

    faq: [
      {
        question: "Where is Lodha/images The Trillion located?",
        answer: `Lodha/images The Trillion is located in Sector 48, Gurgaon, providing excellent connectivity to major business hubs and city landmarks.`,
      },
      {
        question: "What types of homes are available at Lodha/images The Trillion?",
        answer: `Lodha/images The Trillion offers spacious 3 BHK and 4 BHK luxury apartments designed for premium living.`,
      },
      {
        question: "What is the size range of apartments in Lodha/images The Trillion?",
        answer: `The 3 BHK apartments are approximately 2850 sq. ft., and the 4 BHK apartments are around 3600 sq. ft.`,
      },
      {
        question: "What is the price range for apartments at Lodha/images The Trillion?",
        answer: `Prices start from ₹6.14 Crores onwards, depending on the unit size, floor, and view.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, Lodha/images The Trillion is RERA registered.`,
      },
      {
        question: "What is the possession status of Lodha/images The Trillion?",
        answer: `The project is newly launched.`,
      },
      {
        question: "What amenities are offered at Lodha/images The Trillion?",
        answer: `Amenities include a grand clubhouse, swimming pool, gym, spa, kids’ play area, jogging track, and landscaped gardens.`,
      },
      {
        question: "Who is the developer of Lodha/images The Trillion?",
        answer: `Lodha/images The Trillion is developed by Lodha/images Developers, one of India's most trusted and reputed real estate developers, known for quality and innovation.`,
      },
      {
        question: "Is Lodha/images The Trillion a good investment in Gurgaon?",
        answer: `Yes, with its prime location, luxury features, and strong brand reputation, Lodha/images The Trillion is considered an excellent investment option in Gurgaon.`,
      },
      {
        question: "How is the connectivity from Lodha/images The Trillion?",
        answer: `The project enjoys superb connectivity via Golf Course Extension Road and NH-8, offering easy access to major business centers and important city locations.`,
      }
    ],


    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
}